import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:8080/api/v1.3",
});

export default api;
